import { useState } from "react";
import { useAuth } from "@/app/AuthContext";
import { Button } from "@/components/ui/Button";
import { Card } from "@/components/ui/Card";

/**
 * The only thing an unauthenticated visitor can see.
 *
 * Deliberately plain: the v2 design has not been done yet, and borrowing v1's brand components
 * would mean porting a chunk of its library only to discard it at the rewrite.
 */
export function LoginPage() {
  const { login } = useAuth();
  const [isRedirecting, setIsRedirecting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleLogin = async () => {
    setIsRedirecting(true);
    setError(null);
    try {
      await login();
      // On success the browser navigates to Cognito, so this component is unmounted and the
      // button stays disabled for the rest of its life. Only a failure comes back here.
    } catch (err) {
      setError(err instanceof Error ? err.message : "Could not start sign-in.");
      setIsRedirecting(false);
    }
  };

  return (
    <main className="flex min-h-dvh items-center justify-center p-4">
      <Card className="w-full max-w-sm p-8 shadow-md">
        <h1 className="text-xl font-semibold tracking-tight">Biopod v2</h1>
        <p className="mt-2 text-sm text-text-muted">Sign in to continue.</p>

        <Button
          variant="primary"
          fullWidth
          className="mt-8"
          onClick={() => void handleLogin()}
          disabled={isRedirecting}
        >
          {isRedirecting ? "Redirecting…" : "Sign in"}
        </Button>

        {error !== null && (
          <p role="alert" className="mt-4 text-sm text-danger">
            {error}
          </p>
        )}
      </Card>
    </main>
  );
}
